/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';

export interface MonitoringActualsSalesRetrieve$Params {
  id: number;
}

export function monitoringActualsSalesRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalesRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSaleDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalesRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSaleDto>;
    }),
  );
}

monitoringActualsSalesRetrieve.PATH = '/api/monitoring/actuals/sales/{id}/';
